<template>
  <div class="RoundProgressBar flex items-center" title="Етап на играта">
    <div class="uppercase font-stylized font-bold">
      <span class="hidden md:inline">Начало</span>
      <v-icon type="flag-checkered" class="md:hidden" size="2x" />
    </div>
    <div class="RoundProgressBar__progressBarWrapper w-full px-10">
      <div class="RoundProgressBar__progressBar bg-grey-lighter w-full">
        <div :style="{ width: width }" class="RoundProgressBar__progressBarInner bg-red h-1 relative text-red">
          <img src="@/assets/images/rounds/progress_bar_icon.svg" class="RoundProgressBar__Icon">
          <div v-if="shouldShowPercentage" class="RoundProgressBar__percentageCount">
            {{ growingPercentage }} %
          </div>
        </div>
      </div>
    </div>
    <div class="text-center uppercase font-stylized font-bold">
      <span class="hidden md:inline">Финал</span>
      <v-icon type="prize" class="md:hidden" size="2x" />
    </div>
  </div>
</template>

<script>
import { waitFor } from '@/utils/utils'
const MIN_THRESHOLD = 55
const SHOW_PERCENTAGE_AFTER = 75
/**
 * @module RoundProgressBar
 */
export default {
  name: 'RoundProgressBar',
  props: {
    percentage: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      ready: false,
      growingPercentage: 0
    }
  },
  computed: {
    computedPercentage () {
      return this.percentage < MIN_THRESHOLD
        ? MIN_THRESHOLD
        : this.percentage
    },
    width () {
      return this.ready
        ? this.computedPercentage + '%'
        : `0%`
    },
    shouldShowPercentage () { return this.computedPercentage > SHOW_PERCENTAGE_AFTER }
  },
  async mounted () {
    await waitFor(500)
    this.animatePercentage()
    this.ready = true
  },
  methods: {
    animatePercentage () {
      if (this.growingPercentage === this.computedPercentage) return
      requestAnimationFrame(() => {
        this.growingPercentage++
        this.animatePercentage()
      })
    }
  }
}
</script>

<style lang='scss'>
@import '~utils';

.RoundProgressBar__progressBar {
  position: relative;

  &:before, &:after {
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 100%;
    content: '';
    top: 50%;
    transform: translateY(-50%);
  }

  &:before {
    left: 0;
    background: map_get($colors, red);
  }

  &:after {
    z-index: 0;
    right: 0;
    background: map_get($colors, grey-lighter);
  }
}

.RoundProgressBar__progressBarInner {
  width: 0;
  transition: 2s ease-in-out;
}

.RoundProgressBar__Icon {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translate(50%, -50%);
  width: 70px;
  max-width: none;
  z-index: 1;
}

.RoundProgressBar__percentageCount {
  position: absolute;
  right: 0;
  top: 100%;
  transform: translate(50%, 60%);
  width: 50px;
  text-align: center;
}
</style>
